const ddmmyyyy = /^(\d{2})\/(\d{2})\/(\d{4})$/

export const toOptions = (array = [], labelTransform) =>
  array.reduce((options, value) => {
    if (value) options.push({ value, label: labelTransform ? labelTransform(value) : value })
    return options
  }, [])

export const renamePubType = (publicationTypes, pubType, attribute = 'name') =>
  publicationTypes?.[pubType]?.[attribute] || publicationTypes?.[pubType]?.name || ''

export const dateStrToISODate = date => new Date(date.replace(ddmmyyyy, '$3-$2-$1'))

export const withLoading =
  ({ setLoading }) =>
  func =>
  async (...props) => {
    setLoading(true)
    await func(...props)
    setLoading(false)
  }

export const isDitaContent = content => !content.size

export const isWebView = content => {
  const hasSize = content?.size > 0
  const hasPdf = content?.url?.endsWith('.pdf')
  const hasTag = content?.tags?.some(tag => ['Webview'].includes(tag))
  const notHighres = !content?.tags?.some(tag => ['High Res Cover', 'High Res Inset'].includes(tag))
  return hasTag || (hasSize && hasPdf && notHighres)
}

export const isEmpty = obj => !obj || Object.keys(obj).length === 0

export const isObject = obj => Object.prototype.toString.call(obj) === '[object Object]'

/**
 * Returns a new object with a new structure
 * @example
 * toKeyAsIdAndValueAsLabel({ A: 'a', B: 'b' }) // returns { A: { id: 'A', label: 'a' }, B: { id: 'B', label: 'b' } }
 * @param obj
 * @returns {{}}
 */
export const toKeyAsIdAndValueAsLabel = obj =>
  Object.entries(obj).reduce((obj, [key, value]) => {
    obj[key] = { id: key, label: value }
    return obj
  }, {})

export const formatDate = date => {
  let d = new Date(date)
  const tzOffset = d.getTimezoneOffset() * 60000
  d = new Date(d.getTime() + tzOffset)
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
}

/**
 * Converts a date to ISO date string format (YYYY-MM-DD)
 * @param {Date|string} date - The date to format
 * @returns {string} Date string in YYYY-MM-DD format
 * @example
 * toISODateString(new Date('2024-06-10T00:00:00.000Z')) // returns '2024-06-10'
 * toISODateString('2024-06-10') // returns '2024-06-10'
 */
export const toISODateString = date => {
  if (!date) return null
  return new Date(date).toISOString().split('T')[0]
}

export const isServer = () => typeof window === 'undefined'
